module.exports = __webpack_public_path__ + "static/media/10-13.fb0f84bd.mp3";